import { Box, Button, Card, Col, ContainerV2, HeadingThree, Paragraph, Row, Section } from 'hui';
import React from 'react';
import styled from 'styled-components';
import useCheckIe from '../../hooks/useCheckIe';
import ImageCarousel from './ImageCarousel';
import step1 from './images/howitworks-step1.svg';
import step2 from './images/howitworks-step2.svg';
import step3 from './images/howitworks-step3.svg';

const steps = [
  {
    title: '1. Tell us what you need',
    description: 'Answer a few quick questions and even upload a photo.',
    image: step1
  },
  {
    title: '2. Get multiple quotes from professional tradies',
    description: 'Our free service instantly alerts local tradies for quotes to get your job done.',
    image: step2
  },
  {
    title: '3. Choose the best tradie for the job',
    description: 'Compare profiles and verified recommendations to get started.',
    image: step3
  }
];

const Image = styled.img`
  min-height: 100%;
  max-width: 120px;
  display: block;
  width: auto;
  margin: 0 auto 1.5rem;
`;

const HowHipagesWorks = ({ isHidingAction }: Props) => {
  const isItIe = useCheckIe();
  if (isItIe) {
    return null;
  }

  return (
    <Section snow>
      <ContainerV2>
        <Row>
          <Col xs={12} mt={2}>
            <HeadingThree as="h2" align="center">
              How hipages works
            </HeadingThree>
          </Col>
        </Row>
        <Row>
          <ImageCarousel>
            {steps.map(item => (
              <Col key={item.title} xs={12} md={4}>
                <Card align="center">
                  <Image src={item.image} alt={item.title} loading="lazy" />
                  <Paragraph align="center" bold>
                    {item.title}
                  </Paragraph>
                  <Paragraph align="center">{item.description}</Paragraph>
                </Card>
              </Col>
            ))}
          </ImageCarousel>
        </Row>
        {isHidingAction === true ? (
          <Box p={1} />
        ) : (
          <Row m={2}>
            <Col xs={12} align="center">
              <Button tag="a" href="/get_quotes_simple">
                Get started now
              </Button>
            </Col>
          </Row>
        )}
      </ContainerV2>
    </Section>
  );
};

interface Props {
  isHidingAction?: boolean;
}

export default HowHipagesWorks;
